export const DISABILITY_TYPE = [
  { value: 'std', text: 'Short-Term Disability (STD)' },
  { value: 'ltd', text: 'Long-Term Disability (LTD)' },
  { value: 'both', text: 'Both STD and LTD' }
]